module.exports = __webpack_public_path__ + "img/partner-2.76d14ed5.png";